import * as signalR from "@microsoft/signalr";
import store from "../redux/store"; // Import store để dispatch từ service
import { addMessage } from "../redux/slices/messagesSlice";
import { toast } from "react-toastify";
import { formatUtcTime } from "../Helpers/BaseHelper";
class ChatService {
  constructor() {
    this.connection = null;
    this.isConnected = false;
    this.onReceiveMessage = null;
    this.currentChatRoomId = null;
  }

  // ✅ Hàm khởi động SignalR trước
  initSignalR = () => {
    if (!this.connection) {
      this.startConnection(() => {
        console.log("📩 SignalR is ready to receive messages");
      });
    }
  };
  // ✅ Khởi tạo kết nối SignalR
  startConnection = (onReceiveMessage) => {
    if (this.connection) {
      console.warn("⚠️ SignalR connection already exists.");
      return;
    }
    this.onReceiveMessage = onReceiveMessage; // ✅ Gán callback nhận tin nhắn
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl("https://tourvn.runasp.net/chatHub")
      .withAutomaticReconnect([0, 2000, 5000, 10000])
      .build();

    this.connection
      .start()
      .then(async () => {
        this.isConnected = true;
        console.log("✅ Connected to SignalR");

        await this.joinChatRoom(this.currentChatRoomId || 0);
      })
      .catch((err) => console.error("❌ SignalR Connection Error: ", err));

    this.connection.onclose(async () => {
      console.warn("⚠️ SignalR disconnected. Reconnecting...");
      this.isConnected = false;
      setTimeout(() => this.startConnection(onReceiveMessage), 2000);
    });

    this.connection.on(
      "ReceiveMessage",
      (senderId, content, sentAt, fullName) => {
        console.log("📩 Received message from SignalR:", {
          senderId,
          content,
          sentAt,
          fullName,
        });

        // ✅ Cập nhật UI
        onReceiveMessage({ senderId, content, sentAt });
        const currentUser = JSON.parse(localStorage.getItem("userId")) || 0;
        if (+senderId !== +currentUser) {
          toast.success("Bạn có tin nhắn mới từ " + fullName);
        }

        // ✅ Cập nhật Redux
        const localTime = formatUtcTime(sentAt);
        console.log(localTime, "sentAt");
        store.dispatch(addMessage({ senderId, content, sentAt: localTime }));
      }
    );
  };

  // ✅ Cleanup connection
  stopConnection = () => {
    if (this.connection) {
      console.log("❌ Stopping SignalR connection...");
      this.connection.off("ReceiveMessage", this.onReceiveMessage);
      this.connection.stop();
      this.connection = null;
    }
  };

  // ✅ Tham gia phòng chat
  joinChatRoom = async (chatRoomId) => {
    if (this.connection.state === "Connecting") {
      console.log("⏳ Waiting for connection...");
      await new Promise((resolve) => setTimeout(resolve, 1000)); // Chờ 1s
    }
    if (!this.connection || this.connection.state !== "Connected") {
      console.warn("⚠️ Cannot join room, connection not ready");
      return;
    }
    try {
      await this.connection.invoke("JoinChatRoom", chatRoomId);
      this.currentChatRoomId = chatRoomId;
      console.log(`✅ Joined chat room ${chatRoomId}`);
    } catch (error) {
      console.error("❌ Error joining chat room:", error);
    }
  };

  // ✅ Rời phòng chat
  leaveChatRoom = async (chatRoomId) => {
    if (!this.connection || this.connection.state !== "Connected") return;
    try {
      await this.connection.invoke("LeaveChatRoom", chatRoomId);
      console.log(`🚪 Left chat room ${chatRoomId}`);
      this.currentChatRoomId = null;
    } catch (error) {
      console.error("❌ Error leaving chat room:", error);
    }
  };

  // ✅ Kiểm tra kết nối
  checkConnection = async () => {
    if (
      !this.connection ||
      this.connection.state !== signalR.HubConnectionState.Connected
    ) {
      console.warn("⚠️ SignalR is not connected. Reconnecting...");
      await this.startConnection(() => {});
    }
  };

  // ✅ Gửi tin nhắn
  sendMessage = async (chatRoomId, senderId, message) => {
    await this.checkConnection();
    try {
      console.log(`📤 Sending message to room ${chatRoomId}:`, message);
      await this.connection.invoke(
        "SendMessage",
        chatRoomId,
        senderId,
        message
      );
      console.log("✅ Message sent successfully!");
    } catch (error) {
      console.error("❌ Error sending message:", error);
    }
  };
}

export default new ChatService();
